import type { ReactNode } from 'react'

interface ContentGroupProps {
  heading: string
  children: ReactNode
}

export function ContentGroup({
  heading,
  children,
}: ContentGroupProps) {
  return (
    <div className="content-group">
      <div className="content-group-header">{heading}</div>
      <div className="content-group-children">{children}</div>
    </div>
  )
}
